module.exports = __webpack_public_path__ + "img/Zsuzsi_Simon_Alexandru_11.0ee8224d.jpg";